module.exports = "pegasus/assets/themelp1/charity/100.png";